import { Box, Text, Loader } from '@mantine/core';
import { FolderNode } from './folderUtils';
import FolderTreeItem from './FolderTreeItem';

interface FolderTreeProps {
  nodes: FolderNode[];
  selectedId: string | number | null;
  onSelect: (node: FolderNode) => void;
  isLoading?: boolean;
}

export default function FolderTree({ nodes, selectedId, onSelect, isLoading }: FolderTreeProps) {
  if (isLoading) {
    return (
      <Box p="md" style={{ textAlign: 'center' }}>
        <Loader size="sm" />
        <Text size="xs" c="dimmed" mt="xs">Loading folders...</Text>
      </Box>
    );
  }

  if (nodes.length === 0) {
    return (
      <Box p="md" style={{ textAlign: 'center' }}>
        <Text size="sm" c="dimmed">No folders found.</Text>
        <Text size="xs" c="dimmed" mt={4}>Create a root folder to get started.</Text>
      </Box>
    );
  }

  return (
    <Box>
      {nodes.map((node) => (
        <FolderTreeItem
          key={node.id}
          node={node}
          selectedId={selectedId}
          onSelect={onSelect}
        />
      ))}
    </Box>
  );
}
